
  import { Vue, Component, Prop,Watch } from 'vue-property-decorator'
  import echarts from 'echarts'
  import { getCookie, mul } from '../../utils/publish'
  import { UserModule } from '@/store/modules/user'
  @Component
  export default class StudentData extends Vue {
    @Prop() is_index_change
    get_student_count = 0
    get_student_courseTime = 0
    get_xiaoyu5_count = 0
    start_time: string = ''
    end_time: string = ''
    list: any = []
    total_1: any = []
    total_2: any= []
    total_3: any = []
    total_4: any = []
    total_5: any = []
    instrumentTypes: any = []
    teacherType: any = []
    campusType: any = []
    time: any = []
    source: any = []
    ages: any = []

    @Watch('is_index_change')
    getChange(newVal,oldVal) {
      if(newVal) {
        this.getCookieData()
        this.gitCourseType()
        this.getTotal()
      }
    }

    toStudent(url,type) {
      this.$router.push({ path: `/dashboard-student/${url}`, query: { type: type } })
    }

    getCookieData() {
      this.instrumentTypes = JSON.parse(getCookie('instrumentTypes'))
      this.teacherType = JSON.parse(getCookie('teacherType'))
      this.campusType = JSON.parse(getCookie('campusType'))
      this.ages = JSON.parse(getCookie('ages'))
      this.time = JSON.parse(getCookie('time'))
      this.start_time = (Date.parse(<any>this.time[0])/1000).toString()
      this.end_time = (Date.parse(<any>this.time[1])/1000).toString()
    }

    drawLine(dataArr){
      // 基于准备好的dom，初始化echarts实例
      let dom:any = document.getElementById('myChart')
      let myChart = echarts.init(dom)
      // 绘制图表
      myChart.setOption({
        title: {
          text: '学员上课时间段分布',
          textStyle:{
            color:'#333'
          }
        },
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['9-12', '12-14', '14-17', '17-19', '19-22'],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '20%',
            data: dataArr
          }
        ]
      });
    }

    drawLine1(val1,val2){
      // 基于准备好的dom，初始化echarts实例
      let dom:any  = document.getElementById('myChart1')
      let myChart = echarts.init(dom)
      let arrType = []
      for(var i = 0; i < val1.length; i++) {
        arrType.push({type: 'bar',barWidth: '10%',})
      }
      // 绘制图表
      myChart.setOption({
        title: {
          text: '各课程类型的上课时间段分布',
          textStyle:{
            //文字颜色
            color:'#333'
          }
        },
        legend: {
          data: val1,
          top: '10%'
        },
        tooltip: {},
        dataset: {
          source: val2
        },
        xAxis: {type: 'category'},
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: arrType
      });
    }

    async getStudentTotal(val) {
      const res = await UserModule.studentIndex({ data_type: val, instrument_type: this.instrumentTypes.toString(), campus_id: this.campusType.toString(), teacher_id: this.teacherType.toString(),start_time: this.start_time, end_time: this.end_time, ages: this.ages.toString()})
      return res.data
    }

    async gitCourseType() {  // 获取课程种类
      const res = await UserModule.courseType()
      this.list = res.data.list
      for(var i = 0; i < this.list.length; i++) {
        this.total_1.push(0)
        this.total_2.push(0)
        this.total_3.push(0)
        this.total_4.push(0)
        this.total_5.push(0)
      }
      this.getKeCheng()
    }

    getKeCheng() {
      this.getStudentTotal(5).then(data=> {
        const courseArr: any = []
        const courseArr1: any = []
        let sourceArr = []
        const time_type_1 = []
        const time_type_2 = []
        const time_type_3 = []
        const time_type_4 = []
        const time_type_5 = []
        for(var i in data) {
          if(i === '1') {
            time_type_1.push(data[i])
          } else if (i === '2') {
            time_type_2.push(data[i])
          } else if (i === '3') {
            time_type_3.push(data[i])
          } else if (i === '4') {
            time_type_4.push(data[i])
          } else if (i === '5') {
            time_type_5.push(data[i])
          }
        }
        var len:any = this.list.length
        for(let i = 0; i < len; i++) {
          courseArr.push(this.list[i].name)
          courseArr1.push(this.list[i].name)
          for(var j = 0; j < time_type_1.length; j++) {
            for (var k = 0; k < time_type_1[j].length;k++){
              if(time_type_1[j][k].course_type_id) {
                if((time_type_1[j][k].course_type_id).indexOf(this.list[i].id) >= 0) {
                  if(this.list[i].id == time_type_1[j][k].course_type_id) {
                    this.total_1[i] = time_type_1[j][k].count
                  }
                }
              }
            }
          }
          for(var j = 0; j < time_type_2.length; j++) {
            for (var k = 0; k < time_type_2[j].length;k++) {
              if(time_type_2[j][k].course_type_id) {
                if((time_type_2[j][k].course_type_id).indexOf(this.list[i].id) >= 0) {
                  if (this.list[i].id == time_type_2[j][k].course_type_id) {
                    this.total_2[i] = time_type_2[j][k].count
                  }
                }
              }
            }
          }
          for(var j = 0; j < time_type_3.length; j++) {
            for (var k = 0; k < time_type_3[j].length;k++) {
              if(time_type_3[j][k].course_type_id) {
                if((time_type_3[j][k].course_type_id).indexOf(this.list[i].id) >= 0) {
                  if(this.list[i].id == time_type_3[j][k].course_type_id) {
                    this.total_3[i] = time_type_3[j][k].count
                  }
                }
              }
            }
          }
          for(var j = 0; j < time_type_4.length; j++) {
            for (var k = 0; k < time_type_4[j].length;k++) {
              if(time_type_4[j][k].course_type_id) {
                if((time_type_4[j][k].course_type_id).indexOf(this.list[i].id) >= 0) {
                  if(this.list[i].id == time_type_4[j][k].course_type_id) {
                    this.total_4[i] = time_type_4[j][k].count
                  }
                }
              }
            }
          }
          for(var j = 0; j < time_type_5.length; j++) {
            for (var k = 0; k < time_type_5[j].length;k++) {
              if(time_type_5[j][k].course_type_id) {
                if((time_type_5[j][k].course_type_id).indexOf(this.list[i].id) >= 0) {
                  if(this.list[i].id == time_type_5[j][k].course_type_id) {
                    this.total_5[i] = time_type_5[j][k].count
                  }
                }
              }
            }
          }
        }
        courseArr.unshift('product')
        this.total_1.unshift('9-12')
        this.total_2.unshift('12-14')
        this.total_3.unshift('14-17')
        this.total_4.unshift('17-19')
        this.total_5.unshift('19-22')
        sourceArr = [
          courseArr,
          this.total_1,
          this.total_2,
          this.total_3,
          this.total_4,
          this.total_5
        ]
        this.drawLine1(courseArr1,sourceArr)
      })
    }

    async getTotal() {
      this.getStudentTotal(1).then(data=> {
        this.get_student_count = data.count
      })
      this.getStudentTotal(2).then(data=> {
        this.get_student_courseTime = data.count
      })
      this.getStudentTotal(3).then(data=> {
        this.get_xiaoyu5_count = data.count
      })
      this.getStudentTotal(4).then(data=> {
        const dataArr = [0,0,0,0,0]
        for(var i = 0; i < data.length; i++) {
          if (data[i].time_type == 1) {
            dataArr[0] = data[i].count
          } else if (data[i].time_type == 2) {
            dataArr[1] = data[i].count
          } else if (data[i].time_type == 3) {
            dataArr[2] = data[i].count
          } else if (data[i].time_type == 4) {
            dataArr[3] = data[i].count
          } else if (data[i].time_type == 5) {
            dataArr[4] = data[i].count
          }
        }
        this.drawLine(dataArr)
      })
      this.$emit('get-data', false)
    }

    mounted(){
      this.getCookieData()
      this.gitCourseType()
      this.getTotal()
    }
  }
